import { render } from "./InformacionLaboralClienteRegular.vue?vue&type=template&id=4872f8b6"
import script from "./InformacionLaboralClienteRegular.vue?vue&type=script&lang=js"
export * from "./InformacionLaboralClienteRegular.vue?vue&type=script&lang=js"

import "./InformacionLaboralClienteRegular.vue?vue&type=style&index=0&id=4872f8b6&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__